import React from 'react';
import PropTypes from 'prop-types';
import TTMainGrid from './c/ttMainGrid/ttMainGridConnector';
import TTRowsOptions from '../ttRowsOptions/TTRowsOptionsConnector';

class TTRowManager extends React.Component {
  state = {
    acceptedFiles: []
  };

  handleDropAccept = newAcceptedFiles => {
    this.setState(oldState => ({ acceptedFiles: [ ...oldState.acceptedFiles, ...newAcceptedFiles ] }));
    this.props.ttActions.uploadFileTTRows(newAcceptedFiles, { tableId: this.props.translationTableId });
  };

  handleAddLineClick = () => this.props.ttActions.createRow(this.props.sourceColumns, this.props.targetColumn);

  render() {
    return (
      <div>
        <TTRowsOptions onAddLineClick={ this.handleAddLineClick } onDropAccepted={ this.handleDropAccept }/>
        { /*{ this.state.acceptedFiles.map((acceptedFile, index) => <div key={ `${ acceptedFile.name }-${ index }` }>{ acceptedFile.name }</div>)}*/ }
        <TTMainGrid />
        <hr style={ { marginTop: 100, borderColor: '#ccc' } } />
      </div>
    );
  }
}

TTRowManager.propTypes = {
  translationTableId: PropTypes.number.isRequired,
  sourceColumns: PropTypes.array.isRequired,
  targetColumn: PropTypes.object.isRequired,
  ttActions: PropTypes.shape({
    createRow: PropTypes.func,
    uploadFileTTRows: PropTypes.func
  }).isRequired
};

export default TTRowManager;



// WEBPACK FOOTER //
// ./src/shared/components/translationTable/c/ttRowManager/TTRowManager.js